import { render, staticRenderFns } from "./ViewApplication.vue?vue&type=template&id=60795b7c"
import script from "./ViewApplication.vue?vue&type=script&lang=js"
export * from "./ViewApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports